import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const FillFormTaskDefinition: TaskDefinition<'FormsMyMembership'> = {
  taskableTypename: 'FormsMyMembership',
  getUrl: ({ info }) => {
    return info.url || ''
  },
  getTitle: ({ info, affecteeName }) => {
    const surveyName = info.materializedForm?.formTitle

    if (affecteeName && affecteeName.length > 1) {
      return i18n.t('tasks.inbox.titles.survey_affectee', {
        surveyName,
        affecteeName,
      })
    }

    return i18n.t('tasks.inbox.titles.survey_own', {
      surveyName,
    })
  },
}
